// @core/api/endpoints/task/remove_task_custom_field.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Remove custom field value
 * Removes a custom field value from a task. The field definition is not affected.
 */
export async function RemoveTaskCustomField(
  task_id: string,
  field_id: string,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/custom-fields/:field_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  requestPath = requestPath.replace(':field_id', encodeURIComponent(field_id));
  const requestOptions = options;
  return client.delete<TaskResponse>(requestPath, requestOptions);
}
